import barba from '@barba/core';
import views from '../views/views';
import transitions from '../transitions/transitions';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from 'gsap';

export default class Transitions {
	constructor() {
		this.domparser = new DOMParser();

		// Global Barba hooks
		barba.hooks.before(({ current, next, trigger }) => {
			this.removeBlackBodyColor(current.namespace, next.namespace);
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const triggers = ScrollTrigger.getAll();
			triggers.forEach((trigger) => {
				trigger.kill();

				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				trigger.scroll.rec = null;
				const lelijk = setInterval(() => {
					if (trigger.scroll.rec !== null) {
						trigger.scroll.rec = null;
						//console.log("haha toch niet!");
					}
				}, 10);
			});

			const bodyTextColor = next.container.dataset.bodyTextColor;
			const bodyTextColorRgb = next.container.dataset.bodyTextRgb;
			const bodyBackgroundColor = next.container.dataset.bodyBackgroundColor;

			gsap.set(document.body, {
				'--text-color': bodyTextColor,
				'--text-color-rgb': bodyTextColorRgb,
				'--background-color': bodyBackgroundColor,
			});

			const uxStyle = next.container.dataset.uxStylePlaceholder;
			document.body.setAttribute('data-ux-style', uxStyle);

			this.addOrRemovePinkBodyColor(next.namespace);

			const blessEvent = new CustomEvent('bless', {
				detail: {
					next,
				},
			});
			document.dispatchEvent(blessEvent);
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			window.scrollTo(0, 0);
		});

		barba.hooks.after(({ current, next, trigger }) => {
			const afterEvent = new CustomEvent('after', {
				detail: {
					next,
				},
			});
			const page = this.domparser.parseFromString(next.html, 'text/html');

			document.dispatchEvent(afterEvent);

			this.track();
			this.removeMetaFromHead();
			this.addMetaToHead(page);
			this.replaceMobileMenu(page);

			this.addBlackBodyColor(current.namespace, next.namespace);
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPURLS.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (event.type === 'click' && event.target.matches('[data-story-overview]')) {
					event.preventDefault();
					event.stopPropagation();

					return true;
				}

				// Prevent Barba if Custom Story
				// if (href.includes('/story/')) {
				// 	return true;
				// }
			},
			transitions: transitions,
			views: views,
		});
	}

	track() {
		if (!window.WPURLS.in_production) {
			return;
		}

		// ga('set', 'page', window.location.pathname);
		// ga('send', 'pageview');
	}

	replaceMobileMenu(page) {
		const newMobileMenu = page.querySelector('#mobile-menu');
		const oldMobileMenu = document.querySelector('#mobile-menu');

		oldMobileMenu.replaceWith(newMobileMenu);
	}

	removeMetaFromHead() {
		const metaTags = document.querySelectorAll('head meta[property], head .yoast-schema-graph');

		metaTags.forEach((metaTag) => metaTag.remove());
	}

	addMetaToHead(page) {
		try {
			const metaTags = page.querySelectorAll('head meta[property], head .yoast-schema-graph');

			document.head.append(...metaTags);
		} catch {
			console.error('Updating head failed...');
		}
	}

	addOrRemovePinkBodyColor(namespace) {
		if (namespace === 'template-vol-3-chapter') {
			setTimeout(() => {
				document.body.classList.add('body--pink');
			}, 1000);
		} else {
			document.body.classList.remove('body--pink');
		}
	}

	removeBlackBodyColor(currentNamespace, nextNamespace) {
		if (
			nextNamespace != 'template-pollinators-chapter' &&
			nextNamespace != 'template-pollinators' &&
			nextNamespace != 'template-breathing-with-the-forest' &&
			nextNamespace != 'template-film-series-single' &&
			nextNamespace != 'template-film-series-landing'
		) {
			document.body.classList.remove('body--black');
		}
	}

	addBlackBodyColor(currentNamespace, nextNamespace) {
		if (
			nextNamespace === 'template-pollinators-chapter' ||
			nextNamespace === 'template-pollinators' ||
			nextNamespace === 'template-breathing-with-the-forest' ||
			nextNamespace === 'template-film-series-single' ||
			nextNamespace === 'template-film-series-landing'
		) {
			document.body.classList.add('body--black');
		}
	}
}
